export default __webpack_public_path__ + "static/2-dce90ca860846417e5507946f668f219.png";